export default {
  data() {
    return {
      widgetPosition: null,
      dragOffset: { x: 0, y: 0 },
      isDragging: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.keepWidgetInViewport)
  },
  beforeDestroy() {
    this.stopDrag()
    window.removeEventListener('resize', this.keepWidgetInViewport)
  },
  methods: {
    startDrag(event) {
      if (event.button !== 0) return
      const card = event.currentTarget.parentElement
      const rect = card.getBoundingClientRect()
      this.widgetPosition = { left: rect.left, top: rect.top }
      this.dragOffset = { x: event.clientX - rect.left, y: event.clientY - rect.top }
      this.isDragging = true
      document.addEventListener('pointermove', this.dragWidget)
      document.addEventListener('pointerup', this.stopDrag)
      event.preventDefault()
    },
    dragWidget(event) {
      if (!this.isDragging) return
      const card = this.$el.querySelector('#card-file-uploader')
      if (!card) return

      const maxLeft = Math.max(0, window.innerWidth - card.offsetWidth)
      const maxTop = Math.max(0, window.innerHeight - card.offsetHeight)
      this.widgetPosition = {
        left: Math.min(Math.max(0, event.clientX - this.dragOffset.x), maxLeft),
        top: Math.min(Math.max(0, event.clientY - this.dragOffset.y), maxTop),
      }
    },
    stopDrag() {
      this.isDragging = false
      document.removeEventListener('pointermove', this.dragWidget)
      document.removeEventListener('pointerup', this.stopDrag)
    },
    keepWidgetInViewport() {
      if (!this.widgetPosition) return
      const card = this.$el.querySelector('#card-file-uploader')
      if (!card) return

      this.widgetPosition = {
        left: Math.min(this.widgetPosition.left, Math.max(0, window.innerWidth - card.offsetWidth)),
        top: Math.min(this.widgetPosition.top, Math.max(0, window.innerHeight - card.offsetHeight)),
      }
    },
  },
}
